import type { Dispatch, SetStateAction } from 'react';
import { createContext, useContext } from 'react';

export const NavMenuContext = createContext<
  [boolean, Dispatch<SetStateAction<boolean>>]
>([true, () => null]);

export const useNavMenu = () => useContext(NavMenuContext);
